import { httpV2 } from "@/api";

const Qs = require("qs");

/**
 * @summary Promise para os dados para construção do gráfico de vibração das pás.
 * @param {object} monitoringElementId Id do elemento de monitoramento tipo unidade geradora.
 */
const GetBearingVibrationTrends = function(parameters)
{
	const params = {};
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get(`/PitchTrendSignalRecords/${parameters.monitoringElementId}/BladeVibration`, {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
	});
};

/**
 * @summary Promise para os dados para construção do gráfico de deslocamento de pás.
 * @param {object} parameters Parâmetros da requisição.
 */
const GetBladeDisplacementTrends = function(parameters)
{
	const params = {};
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get(`/PitchTrendSignalRecords/${parameters.monitoringElementId}/BladeDisplacement`, {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
	});
};

/**
 * @summaryv Promise para os dados para construção do gráfico de corrente de acionamento das motorredutoras.
 * @param {object} parameters Parâmetros da requisição.
 */
const GetReducerMotorCurrentTrends = function(parameters)
{
	const params = {};
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get(`/PitchTrendSignalRecords/${parameters.monitoringElementId}/ReducerMotorCurrent`, {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
	});
};

/**
 * @summary Promise para os o valor do último valor de pitch para o mostrador gauge.
 * @param {object} parameters Parâmetros da requisição.
 */
const GetLatestPitchGauge = function(parameters)
{
	return httpV2.get(`/PitchTrendSignalRecords/${parameters.monitoringElementId}/LatestPitchGauge`);
};

export default
{
	GetBladeDisplacementTrends,
	GetBearingVibrationTrends,
	GetLatestPitchGauge,
	GetReducerMotorCurrentTrends,
};